import Breadcrumb from "../components/Breadcrumb";
import Plans from "../components/Plans ";

const PlansPage = () => {
  return (
    <>
      <Breadcrumb title="Pricing Plan" />

      <Plans />
    </>
  );
};

export default PlansPage;
